const LikeMap = {
  Sweets: {
    value: 'Sweets',
    smallIcon: require('@/assets/images/icons/sweets.svg'),
    largeIcon: require('@/assets/images/icons/sweets.svg'),
    categoryIcon: require('@/assets/images/like-icon/sweets/all.svg'),
    values: [
      { value: 'b2', text: 'Bubble Tea', icon: require('@/assets/images/like-icon/sweets/bubble-tea.svg'), },
      { value: 'c1', text: 'Cakes', icon: require('@/assets/images/like-icon/sweets/cakes.svg'), },
      { value: 'c3', text: 'Chocolate', icon: require('@/assets/images/like-icon/sweets/chocolate.svg'), },
      { value: 'c2', text: 'Cream Puff', icon: require('@/assets/images/like-icon/sweets/cream-puff.svg'), },
      { value: 'd1', text: 'Donuts', icon: require('@/assets/images/like-icon/sweets/donuts.svg'), },
      { value: 'i1', text: 'Ice Cream', icon: require('@/assets/images/like-icon/sweets/ice-cream.svg'), },
      { value: 'j2', text: 'Juice', icon: require('@/assets/images/like-icon/sweets/juice.svg'), },
      { value: 'm1', text: 'Matcha', icon: require('@/assets/images/like-icon/sweets/matcha.svg'), },
      { value: 'p4', text: 'Pancakes', icon: require('@/assets/images/like-icon/sweets/pancakes.svg'), },
      { value: 'p3', text: 'Pudding', icon: require('@/assets/images/like-icon/sweets/pudding.svg'), },
      { value: 's1', text: 'Shaved Ice', icon: require('@/assets/images/like-icon/sweets/shaved-ice.svg'), },
      { value: 'sa', text: 'Smoothy', icon: require('@/assets/images/like-icon/sweets/smoothy.svg'), },
      { value: 't1', text: 'Taiyaki', icon: require('@/assets/images/like-icon/sweets/taiyaki.svg'), },
      { value: 'w4', text: 'Waffels', icon: require('@/assets/images/like-icon/sweets/waffels.svg'), },
      { value: 'w3', text: 'Wagashi', icon: require('@/assets/images/like-icon/sweets/wagashi.svg'), },
      { value: 'o4', text: 'Other', icon: require('@/assets/images/like-icon/sweets/other.svg'), },
    ],
  },
  Food: {
    value: 'Food',
    smallIcon: require('@/assets/images/icons/food.svg'),
    largeIcon: require('@/assets/images/icons/food.svg'),
    categoryIcon: require('@/assets/images/like-icon/food/all.svg'),
    values: [
      { value: 'b6', text: 'Bakery', icon: require('@/assets/images/like-icon/food/bakery.svg'), },
      { value: 'b7', text: 'BBQ / Yakiniku', icon: require('@/assets/images/like-icon/food/bbq-yakiniku.svg'), },
      { value: 'b8', text: 'Brunch', icon: require('@/assets/images/like-icon/food/brunch.svg'), },
      { value: 'c5', text: 'Coffee', icon: require('@/assets/images/like-icon/food/coffee.svg'), },
      { value: 'c6', text: 'Craft Beer', icon: require('@/assets/images/like-icon/food/craft-beer.svg'), },
      { value: 'c4', text: 'Curry', icon: require('@/assets/images/like-icon/food/curry.svg'), },
      { value: 'd3', text: 'Dim Sum', icon: require('@/assets/images/like-icon/food/dim-sum.svg'), },
      { value: 'i2', text: 'Irish Pub', icon: require('@/assets/images/like-icon/food/irish-pub.svg'), },
      { value: 'j1', text: 'Japanese Sake', icon: require('@/assets/images/like-icon/food/japanese-sake.svg'), },
      { value: 'l1', text: 'Local Food', icon: require('@/assets/images/like-icon/food/local-food.svg'), },
      { value: 'o1', text: 'Okonomiyaki', icon: require('@/assets/images/like-icon/food/okonomiyaki.svg'), },
      { value: 'o2', text: 'Oyster', icon: require('@/assets/images/like-icon/food/oyster.svg'), },
      { value: 'r1', text: 'Ramen', icon: require('@/assets/images/like-icon/food/ramen.svg'), },
      { value: 'sb', text: 'Spicy Food', icon: require('@/assets/images/like-icon/food/spicy-food.svg'), },
      { value: 's4', text: 'Standing Bar', icon: require('@/assets/images/like-icon/food/standing-bar.svg'), },
      { value: 's5', text: 'Street Food', icon: require('@/assets/images/like-icon/food/street-food.svg'), },
      { value: 's3', text: 'Sushi', icon: require('@/assets/images/like-icon/food/sushi.svg'), },
      { value: 't2', text: 'Tea', icon: require('@/assets/images/like-icon/food/tea.svg'), },
      { value: 'v1', text: 'Vegan Food', icon: require('@/assets/images/like-icon/food/vegan-food.svg'), },
      { value: 'w5', text: 'Wine / Winery', icon: require('@/assets/images/like-icon/food/wine-winery.svg'), },
      { value: 'o5', text: 'Other', icon: require('@/assets/images/like-icon/food/other.svg'), },
    ],
  },
  Sports: {
    value: 'Sports',
    smallIcon: require('@/assets/images/icons/sports.svg'),
    largeIcon: require('@/assets/images/icons/sports.svg'),
    categoryIcon: require('@/assets/images/like-icon/sports/all.svg'),
    values: [
      { value: 'b9', text: 'Badminton', icon: require('@/assets/images/like-icon/sports/badminton.svg'), },
      { value: 'b1', text: 'Batting Cage', icon: require('@/assets/images/like-icon/sports/batting-cage.svg'), },
      { value: 'b3', text: 'Bouldering', icon: require('@/assets/images/like-icon/sports/bouldering.svg'), },
      { value: 'c7', text: 'Cycling', icon: require('@/assets/images/like-icon/sports/cycling.svg'), },
      { value: 'd2', text: 'Dancing', icon: require('@/assets/images/like-icon/sports/dancing.svg'), },
      { value: 'f1', text: 'Futsal / Soccer', icon: require('@/assets/images/like-icon/sports/futsal-soccer.svg'), },
      { value: 'r2', text: 'Rugby', icon: require('@/assets/images/like-icon/sports/rugby.svg'), },
      { value: 'k4', text: 'Karate', icon: require('@/assets/images/like-icon/sports/karate.svg'), },
      { value: 's7', text: 'Skiing', icon: require('@/assets/images/like-icon/sports/skiing.svg'), },
      { value: 's8', text: 'Snowboarding', icon: require('@/assets/images/like-icon/sports/snowboarding.svg'), },
      { value: 'se', text: 'SUP', icon: require('@/assets/images/like-icon/sports/sup.svg'), },
      { value: 's6', text: 'Surfing', icon: require('@/assets/images/like-icon/sports/surfing.svg'), },
      { value: 't3', text: 'Table Tennis', icon: require('@/assets/images/like-icon/sports/table-tennis.svg'), },
      { value: 'w1', text: 'Watch Baseball', icon: require('@/assets/images/like-icon/sports/watch-baseball.svg'), },
      { value: 'w6', text: 'Watch Basketball', icon: require('@/assets/images/like-icon/sports/watch-basketball.svg'), },
      { value: 'w2', text: 'Watch Soccer', icon: require('@/assets/images/like-icon/sports/watch-soccer.svg'), },
      { value: 'o6', text: 'Other', icon: require('@/assets/images/like-icon/sports/other.svg'), },
    ],
  },
  Fun: {
    value: 'Fun',
    smallIcon: require('@/assets/images/icons/fun.svg'),
    largeIcon: require('@/assets/images/icons/fun.svg'),
    categoryIcon: require('@/assets/images/like-icon/fun/all.svg'),
    values: [
      { value: 'a3', text: 'Amusement Arcade', icon: require('@/assets/images/like-icon/fun/amusement-arcade.svg'), },
      { value: 'a1', text: 'Anime / Manga', icon: require('@/assets/images/like-icon/fun/anime-manga.svg'), },
      { value: 'a4', text: 'Architecture', icon: require('@/assets/images/like-icon/fun/architecture.svg'), },
      { value: 'a2', text: 'Art Museum', icon: require('@/assets/images/like-icon/fun/art-museum.svg'), },
      { value: 'ba', text: 'Baking', icon: require('@/assets/images/like-icon/fun/baking.svg'), },
      { value: 'bb', text: 'Beekeeping', icon: require('@/assets/images/like-icon/fun/beekeeping.svg'), },
      { value: 'b5', text: 'Board Game', icon: require('@/assets/images/like-icon/fun/board-game.svg'), },
      { value: 'b4', text: 'Bowling', icon: require('@/assets/images/like-icon/fun/bowling.svg'), },
      { value: 'c9', text: 'Camera', icon: require('@/assets/images/like-icon/fun/camera.svg'), },
      { value: 'ca', text: 'Camping', icon: require('@/assets/images/like-icon/fun/camping.svg'), },
      { value: 'cb', text: 'Caving', icon: require('@/assets/images/like-icon/fun/caving.svg'), },
      { value: 'c8', text: 'Coding', icon: require('@/assets/images/like-icon/fun/coding.svg'), },
      { value: 'cc', text: 'Composing', icon: require('@/assets/images/like-icon/fun/composing.svg'), },
      { value: 'd4', text: 'Disney', icon: require('@/assets/images/like-icon/fun/disney.svg'), },
      { value: 'f2', text: 'Fassion', icon: require('@/assets/images/like-icon/fun/fassion.svg'), },
      { value: 'h2', text: 'Fishing', icon: require('@/assets/images/like-icon/fun/fishing.svg'), },
      { value: 'h1', text: 'Hiking', icon: require('@/assets/images/like-icon/fun/hiking.svg'), },
      { value: 'i3', text: 'Illustrating / Drawing', icon: require('@/assets/images/like-icon/fun/illustrating-drawing.svg'), },
      { value: 'k1', text: 'Karaoke', icon: require('@/assets/images/like-icon/fun/karaoke.svg'), },
      { value: 'k2', text: 'Kendama', icon: require('@/assets/images/like-icon/fun/kendama.svg'), },
      /*{ value: 'm2', text: 'Manga', },*/
      { value: 'k3', text: 'Knitting', icon: require('@/assets/images/like-icon/fun/knitting.svg'), },
      { value: 'p5', text: 'Playing Bass', icon: require('@/assets/images/like-icon/fun/playing-bass.svg'), },
      { value: 'p6', text: 'Playing Guiter', icon: require('@/assets/images/like-icon/fun/playing-guiter.svg'), },
      { value: 'p1', text: 'Pokemon', icon: require('@/assets/images/like-icon/fun/pokemon.svg'), },
      { value: 's2', text: 'Sento / Onsen', icon: require('@/assets/images/like-icon/fun/sento-onsen.svg'), },
      { value: 's9', text: 'Shrine/Temple', icon: require('@/assets/images/like-icon/fun/shrine-temple.svg'), },
      { value: 'sc', text: 'Songwriting', icon: require('@/assets/images/like-icon/fun/songwriting.svg'), },
      { value: 'sd', text: 'Spending time on the beach', icon: require('@/assets/images/like-icon/fun/spending-time-on-the-beach.svg'), },
      { value: 't4', text: 'Taiko', icon: require('@/assets/images/like-icon/fun/taiko.svg'), },
      { value: 't5', text: 'Restroom', icon: require('@/assets/images/like-icon/fun/toilet.svg'), },
      { value: 'v2', text: 'Video Game', icon: require('@/assets/images/like-icon/fun/video-game.svg'), },
      { value: 'v3', text: 'Visiting Castles', icon: require('@/assets/images/like-icon/fun/visiting-castles.svg'), },
      { value: 'w7', text: 'Watch movies', icon: require('@/assets/images/like-icon/fun/watch-movies.svg'), },
      { value: 'y1', text: 'Yoga', icon: require('@/assets/images/like-icon/fun/yoga.svg'), },
      { value: 'o3', text: 'Other', icon: require('@/assets/images/like-icon/fun/other.svg'), },
    ],
  }
}
export default {
  list: [
    LikeMap.Sweets,
    LikeMap.Food,
    LikeMap.Sports,
    LikeMap.Fun,
  ],
  map: LikeMap,
  groupIcon: (groupName) => {
    return LikeMap[groupName].categoryIcon
  },
  likeCodeToLikeInfo: (likeCode) => {
    const keys = Object.keys(LikeMap)
    for (let i = 0 ; i < keys.length ; i++) {
      const likeGroup = LikeMap[keys[i]]
      for (let j = 0 ; j < likeGroup.values.length ; j++) {
        const like = likeGroup.values[j]
        if (like.value == likeCode) {
          return {
            groupName: likeGroup.value,
            groupIcon: likeGroup.smallIcon,
            likeCode: likeCode,
            likeName: like.text,
          }
        }
      }
    }
  }
}
